<template>
    <div class="contant" v-title="pageTitle">
        <div class="cont">
            <van-form @submit="onSubmit">
                <van-field disabled v-model="goods.goodsSn" name="商品编号" label="商品编号" placeholder="请输入商品名称"
                    :rules="[{ required: true, message: '商品编号' }]" />
                <van-field required v-model="goods.name" name="商品名称" label="商品名称" placeholder="请输入商品名称"
                    :rules="[{ required: true, message: '商品名称' }]" />

                <van-field v-model="goods.counterPrice" name="市场价格" label="市场价格" placeholder="0.00" />

                <!-- 文件上传 -->
                <van-field name="uploader" label="商品图片">
                    <template #input>
                        <van-uploader v-model="uploader" :max-count="1"  :after-read="afterRead0" />
                    </template>
                </van-field>
                <van-field name="uploader_" label="宣传画廊">
                    <template #input>
                        <van-uploader v-model="uploader_" :max-count="5"  :after-read="afterRead1" @delete="Delete" />
                    </template>
                </van-field>
                <!-- 单位 -->
                <van-field v-model="goods.unit" name="商品单位" label="商品单位" placeholder="件/个/盒" />
                <!-- 所属分类 -->
                <div> 
                    <van-field required readonly name="所属分类" label="所属分类" placeholder="(点击选择分类)" @click="showchoose" />
                    <div style="display: flex;flex-wrap: wrap;background: #fff;"> 
                        <div v-for="(itmes,index) in taglist" :key="index"> 
                     <van-tag style="margin-right: 5px;margin-left: 5px;" closeable size="large" type="primary" @close="close(index)">{{ itmes.text }}</van-tag>
                    </div>
                    </div>                  
                </div>
                <!-- 简介 -->
                <div> 
                    <van-field rows="4" type="textarea" autosize v-model="goods.brief" name="商品简介" label="商品简介" placeholder="请输入商品简介" />
                </div>
                <!-- 商品详情 -->
                <div> 
                    <van-field name="uploader_d" label="商品详情">
                    <template #input>
                        <van-uploader v-model="uploader_d" :max-count="30" :after-read="afterRead3" @delete="Delete3"  />
                    </template>
                </van-field>
                </div>
               
            </van-form>
            </div>
            <div class="cont"> 
                <van-field name="货品规格列" label="货品规格列" disabled placeholder="(标准)"/>
                <van-field v-model="products[0].price" name="货品售价" label="货品售价" placeholder="请输入价格" />
                <van-field v-show="isPartner==1" v-model="products[0].commission" name="货品佣金" label="货品佣金" placeholder="请输入货品佣金" />
                <van-field v-model="products[0].number" name="货品数量" label="货品数量" placeholder="请输入货品数量" />
                <van-field name="uploader" label="货品图片">
                    <template #input>
                        <van-uploader v-model="priceuploader" :max-count="1" :after-read="afterRead2" />
                    </template>
                </van-field>
            </div>
            <div class="cont"> 
                <van-field name="商品参数" label="商品参数" disabled placeholder="(点此添加)" @click.stop="showd=true" />
                <div style="background: #fff;"> 
                    <div v-for="(items,index) in attributes" :key="index">
                        <div style="display: flex;padding: 10px;font-size: 16px;align-items: center;"> 
                            <div style="width:30%;text-align: left;">{{ items.attribute }}: </div>
                            <div style="width:50%;text-align: left;">{{ items.value }}</div>
                            <van-button type="danger" size="small" round @click.stop="del(index)">删除</van-button>
                        </div>
                    </div>
                </div>
                 <div style="margin: 46px;">
                    <van-button round block type="info" native-type="submit" @click.stop="update">提交</van-button>
                </div>
            </div>
            <van-popup v-model="showselcet"  position="bottom" :style="{ height: '55%' }">
                <div style="padding: 3px;"> 
                   <van-tree-select :items="categoryList" :active-id.sync="activeId" :main-active-index.sync="activeIndex" @click-item="clickItem" /> 
                </div>
                <van-button type="info" size="small" @click.stop="confirmchoose">确认选择</van-button>
            </van-popup>
            <van-dialog v-model="showd" title="添加商品参数" show-cancel-button :before-close="onBeforeClose" @confirm="confirm">
                <van-field v-model="c0" name="参数名称" label="参数名称" label-width="100px" placeholder="请输入参数名称" />
                <van-field v-model="c1" name="参数值" label="参数值" label-width="100px" placeholder="请输参数值"  style="padding-bottom: 20px;" />
            </van-dialog>
    </div>
</template>

<script>
import request from '../api/request'
const baseurl='https://yekjapi.wghuang.work'
export default {
    data() {
        return {
            pageTitle: '商品上架', proName: '', number: Math.round(Date.parse(new Date())+Math.random()*10000), marketPrice: '',unit:'',showselcet:false,introduction:'',
            uploader:[],uploader_:[],taglist:[],categoryList:[],activeId: null,activeIndex: 0,
            uploader_d:[],price:0,priceunit:0,priceNumber:0,priceuploader:[],c0:'',c1:'',showd:false,
            canshu:[],sel:'',selobj:{},isPartner:0,
            uploadurl:'/admin/storage/create',
            goods: { picUrl: '', gallery: [], isHot: false, isNew: true, isOnSale: true, unit: '件',name:'',goodsSn:Math.round(Date.parse(new Date())+Math.random()*10000), counterPrice:'',commission:'',categoryIds:[],detail:[],brief:''},
            specifications: [{ specification: '规格', value: '标准', picUrl: '' }],
            products: [{ id: 0, specifications: ['标准'], price: 0.00, commission: 0.00, number: 0, url: '' }],
            attributes: [],
            // {name:'出版社名称',value:'北京首都师范大学出版'},{name:'正：副书名',value:'人教版'},{name:'出版社名称',value:'人教版'}
        }
    },
    mounted() {
        this.userinfo=JSON.parse(localStorage.getItem('usermsg'))
        this.checkPartner()
        request.getcommerlist({},'/admin/goods/catAndBrand','get',localStorage.getItem('token_yr'),res=>{
            console.log(res)
            if(res.errno==0){
                this.categoryList=JSON.parse(JSON.stringify(res.data.categoryList).replace(/label/g,'text').replace(/value/g,'id'))
                console.log(this.categoryList)
            }  
        })
    },
    methods: {
        checkPartner(){
            const param = {
              orgCode: this.userinfo.orgCode
              }
            request.getcommerlist(param,'/admin/shop/checkPartner','get',localStorage.getItem('token_yr'),res=>{
            console.log(res.data)
            if(res.errno==0){
                this.isPartner = res.data
            }  
        })
        },
        afterRead0(file){
            console.log(file)
            const fd = new FormData();
            fd.append('file', file.file)
            fd.append('fileType', 'file')
            request.getcommerlist(fd,this.uploadurl,'post',localStorage.getItem('token_yr'),res=>{
                if(res.errno==0){
                    console.log(res.data.url)
                    // this.uploader[0].picUrl=res.data.url
                    this.goods.picUrl=res.data.url
                }
            })
        },
        afterRead2(file){
            const fd = new FormData();
            fd.append('file', file.file)
            fd.append('fileType', 'file')
            request.getcommerlist(fd,this.uploadurl,'post',localStorage.getItem('token_yr'),res=>{
                if(res.errno==0){
                    console.log(res.data.url)
                    // this.priceuploader[0]=res.data.url
                    this.specifications[0].picUrl=res.data.url
                    console.log(this.specifications)
                }
            })
        },

        afterRead3(file){
            let that=this
            const fd = new FormData();
            fd.append('file', file.file)
            fd.append('fileType', 'file')
            console.log(file)
            request.getcommerlist(fd,that.uploadurl,'post',localStorage.getItem('token_yr'),res=>{
                if (res.errno == 0) {
                    console.log(res.data.url)
                    // if(that.uploader_d.length==0) that.uploader_d[0]=res.data.url
                    // else that.uploader_d.push(res.data.url)
                    console.log(that.uploader_d)
                    var image = new Image()
                    image.src = res.data.url
                    image.onload = function () {
                        var width = image.width;
                        var height = image.height;
                        console.log(width + '======' + height);
                        that.goods.detail.push({url:res.data.url,width:width,height:height})
                    }
                }
            })
        },
        Delete3(file,detail){
            this.goods.detail.splice(detail.index, 1)
            this.uploader_d.splice(detail.index, 1)
        },
        afterRead1(file){
            const fd = new FormData();
            fd.append('file', file.file)
            fd.append('fileType', 'file')
            request.getcommerlist(fd,this.uploadurl,'post',localStorage.getItem('token_yr'),res=>{
                if(res.errno==0){
                    console.log(res.data.url)
                    this.goods.gallery.push(res.data.url)
                }
            })
        },
        Delete(file,detail){
            // console.log(file)
            // console.log(detail.index)
            this.goods.gallery.splice(detail.index, 1)
        },
        onSubmit() { },
        close(e){
            this.taglist.splice(e,1)
        },
        showchoose(){
            // console.log('sss')
            this.showselcet=true
        },
        clickItem(e){
            console.log(this.activeIndex)
            // this.showselcet=false
             if(this.sel!=e.id){
                 this.sel=e.id
                 this.selobj=e
             }else{
                this.selobj={}
                this.activeId=null
             }
            //  console.log(this.activeId)
             //if(e.id==this.activeId) this.activeId=null
            // if(this.taglist.indexOf(e.text)==-1){
            //     this.taglist.push(e.text)  
            // }

            // console.log(this.taglist)
        },
        confirmchoose(){
            var newobj={}
            if(this.activeId==null){
                  newobj.id=this.categoryList[this.activeIndex].id
                  newobj.text=this.categoryList[this.activeIndex].text
                  console.log(newobj)
            }else{
                newobj=JSON.parse(JSON.stringify(this.selobj))
                newobj.text=this.categoryList[this.activeIndex].text+'/'+ newobj.text
                newobj.uid=this.categoryList[this.activeIndex].id
                console.log(newobj)
            }
            // return
            if(this.taglist.indexOf(newobj.text)==-1){
                this.taglist.push(newobj)  
                this.selobj={}
                this.activeId=null
                this.showselcet=false
                // this.goods.categoryIds=[]
                this.goods.categoryIds.push('['+newobj.uid+','+newobj.id+']')
                // this.goods.categoryIds=this.goods.categoryIds.substring(0,this.goods.categoryIds.length-1)
            }
        },
        onBeforeClose(action, done) {
            if (action === "confirm") {
                return done(false);
            } else {
                // 重置表单校验
                return done();
            }
        },
        confirm(){
           if(this.co==''||this.c1==''){
               return
           }
        //    this.canshu.push({name:this.c0,value:this.c1})
           var obj={}
           obj.attribute=this.c0
           obj.value=this.c1
           this.attributes.push(obj)
           this.showd=false
           this.c0=''
           this.c1=''
           console.log(this.attributes)
        },
        del(e){
            this.attributes.splice(e,1)
            this.goods.categoryIds.splice(e,1)
        },
        update(){
            if(this.goods.name==''){
                this.$dialog.alert({
                    message: '商品名称不能为空！',
                });
                return
            }
            if(this.taglist.length==0){
                this.$dialog.alert({
                    message: '所属分类不能为空！',
                });
                return
            }
            var goods=JSON.parse(JSON.stringify(this.goods))
            var newDetail=''
            for(let i in goods.detail){
                newDetail+='<p><img src="'+goods.detail[i].url+'" alt="" width="'+goods.detail[i].width+'" height="'+goods.detail[i].height+'" /></p>'
            }
            goods.detail=goods.detail.toString()
            goods.detail=newDetail
            goods.categoryIds=goods.categoryIds.toString()
            const finalGoods = {
             goods: goods,
             specifications: this.specifications,
             products: this.products,
             attributes: this.attributes
          }
        //   console.log(finalGoods)
        //   return
          request.getcommerlist(finalGoods,'/admin/goods/create','post',localStorage.getItem('token_yr'),res=>{
               console.log(res)
                this.$toast(res.errmsg)
                if(res.errno==0){
                    this.$router.back()
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.contant {
    background: #edebeb;
    height: 100%;
    width: 100%;
    overflow: scroll;
}

/deep/ .van-field {
    font-size: 16px;
}
/deep/ .van-sidebar-item__text{padding-top:10px;padding-bottom: 10px;font-size: 16px;}
/deep/ .van-tree-select__item{font-size: 16px;}
// /deep/ .van-icon-checked{margin-bottom: 10px;}
.cont {
    padding: 5px;
}
.mg{margin-right: 10px;}
</style>